import {DomainEvent} from './DomainEvent';
import {News} from '../resources/News';

export class NewsUnpublished extends DomainEvent<News> {}
